import { fetchFormConfigurations } from "../../inputFormConfigurations";
import { apiInitialState } from "../../../utils/apiStateUtils";
export function Default() {
  return {
    isFormValid: false,
    peopleListApi: apiInitialState(),
    peopleTabelSearch: fetchFormConfigurations(["tableSearch"]),
  };
}
